var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: [
            {
              text: "Guardar",
              icon: "fas fa-save",
              variant: "success",
              click:
                this.model.amendmentFlag == "1"
                  ? this.UpdateAmendment
                  : this.save,
              visible: this.enableSaveButton
            },
            {
              text: "Imprimir",
              icon: "fas fa-file",
              variant: "outline-success",
              click: this.printContractAmendment,
              visible: this.canPrint
            },
            {
              text: "Firmar Enmienda",
              icon: "fas fa-pen-alt",
              variant: "success",
              click: this.signContract,
              visible: this.canSign
            }
          ],
          "on-return": () => _vm.$router.go(-1),
          page: _vm.page
        }
      }),
      _c("board", { staticClass: "mb-2", attrs: { details: _vm.boardData } }),
      _c(
        "div",
        { staticClass: "c-tabs" },
        [
          _c(
            "b-tabs",
            {
              attrs: {
                "content-class": "mt-4",
                "nav-class": "custom-nav-container",
                "no-nav-style": true
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { active: "", title: "Información de Enmienda" } },
                [
                  _c(
                    "div",
                    [
                      _vm.isLoaded
                        ? _c(
                            "validation-observer",
                            { ref: "formValidator" },
                            [
                              _c("information", {
                                attrs: { "is-read-only": _vm.isReadOnly },
                                model: {
                                  value: _vm.model.information,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "information", $$v)
                                  },
                                  expression: "model.information"
                                }
                              }),
                              _vm.model.information.amendmentTypeDateFlag
                                ? _c("validity-information", {
                                    key: "validity-amendment",
                                    ref: "validityInformation",
                                    attrs: {
                                      "can-edit-vigency":
                                        _vm.canEditAmendmentVigency,
                                      "is-read-only": _vm.isReadOnly
                                    },
                                    on: { "save-vigency": _vm.onSaveVigency },
                                    model: {
                                      value: _vm.model.validity,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "validity", $$v)
                                      },
                                      expression: "model.validity"
                                    }
                                  })
                                : _vm._e(),
                              _vm.model.amendmentFlag
                                ? _c("amendment-document", {
                                    ref: "amendmentDocument"
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.information.amendmentTypeBalanceFlag
                        ? _c("separation-of-funds", {
                            ref: "FundSeparation",
                            attrs: {
                              bus: _vm.bus,
                              "can-edit-balance":
                                _vm.model.information.amendmentTypeBalanceFlag,
                              "contract-id": _vm.model.id,
                              "fiscal-year-description":
                                _vm.model.validity.fiscalYearDescription,
                              "is-amendment":
                                _vm.model.amendmentFlag ||
                                _vm.model.information.amendmentTypeBalanceFlag,
                              "is-contract-signed": _vm.model.isSignedFlag
                            }
                          })
                        : _vm._e(),
                      _vm.showSections
                        ? _c("SIFDEInformation", {
                            staticClass: "mt-5",
                            attrs: {
                              "academic-year": _vm.academicYear,
                              "contract-number":
                                _vm.contractNumberFinancialSystem
                            }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.canShowContractServices(
                                _vm.model.information
                              ),
                              expression:
                                "canShowContractServices(model.information)"
                            }
                          ],
                          staticClass: "mt-5"
                        },
                        [
                          _c("service-information-list", {
                            attrs: {
                              "add-enabled": _vm.userHasPermissions(
                                "provider.contract.services.add"
                              ),
                              "contract-id": _vm.contractId,
                              "delete-enabled":
                                !_vm.isReadOnly &&
                                _vm.userHasPermissions(
                                  "provider.contract.services.delete"
                                ),
                              "edit-enabled": _vm.canEditService,
                              "on-deleting": _vm.onServiceDeleting,
                              "on-saving": _vm.onServiceSaving
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm.proposalRequestId != null
                ? _c(
                    "b-tab",
                    { attrs: { title: "Documentos de Contratación" } },
                    [
                      _c("contrat-tab", {
                        attrs: {
                          "auto-remove-document": true,
                          "is-amendment": true,
                          "proposal-request-id": Number(_vm.proposalRequestId)
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }